/*
================================================================ 
		 Copyright (c) 2018-2022 Digitize Things Inc.           
					 All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../../sales/reports/reports.module.css";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import { Select, TableContainer, Tooltip } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Button from "../../../component/button";
import Chip from "@mui/material/Chip";
import { formatNumber } from "../../../helper/numberFormatter";
import { formatDate } from "../../../helper/dateFormatter";
import { withTranslation } from "react-i18next";

const MyTask = (props) => {
  const t = props.t;
  const mainStyle = {
    maxWidth: "auto",
    margin: "auto",
    padding: "auto",
    paddingTop: "0",
    paddingRight: "0",
    backgroundColor: "transparent",
  };
  return (
    <div>
      <TableContainer>
        <Table className={classes.shippingTableClass + " " + "newGlobalTable"}>
          <TableHead>
            {/* <TableRow>
                        <TableCell colSpan={5}>
                            <h3 style={{ marginTop: 0, marginBottom: 0 }}>{t('MY_TASK')}</h3>
                        </TableCell>
                    </TableRow> */}
            {/* <TableRow> */}
            <TableRow>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("workEffortName");
                }}
              >
                <b>{t("TASK_NAME")}</b>
                {/* Sort indication */}
                {props.sortBy === "workEffortName" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>

              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("taskEntityId");
                }}
              >
                <b>{t("TASK_ENTITY_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "taskEntityId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("workEffortId");
                }}
              >
                <b> {t("TASK_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "workEffortId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {(props.securityGroupsList.includes("PARTNER_ADMIN") ||
                props.securityGroupsList.includes("ADMIN")) && (
                <TableCell>
                  <b>{t("ASSIGNED_TO")}</b>
                </TableCell>
              )}
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("currentStatusId");
                }}
              >
                <b>{t("TASK_STATUS")}</b>
                {/* Sort indication */}
                {props.sortBy === "currentStatusId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>

              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("fromDate");
                }}
              >
                <b>{t("TASK_DATE")}</b>
                {/* Sort indication */}
                {props.sortBy === "fromDate" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>
              {(props.securityGroupsList.includes("PARTNER_ADMIN") ||
                props.securityGroupsList.includes("ADMIN")) && (
                <TableCell>
                  <b>{t("ACTION")}</b>
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.tasksList ? (
              <>
                {props.tasksList &&
                  props.tasksList.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          props.openTaskLink(row);
                        }}
                      >
                        {row.taskName}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          props.openTaskLink(row);
                        }}
                      >
                        {row.taskItem}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          props.openTaskLink(row);
                        }}
                      >
                        {row.taskId}
                      </TableCell>
                      {(props.securityGroupsList.includes("PARTNER_ADMIN") ||
                        props.securityGroupsList.includes("ADMIN")) && (
                        <TableCell
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            props.openTaskLink(row);
                          }}
                        >
                          {row.assignedPerson}
                        </TableCell>
                      )}
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          props.openTaskLink(row);
                        }}
                      >
                        <Chip
                          size="normal"
                          style={{ cursor: "pointer" }}
                          className={
                            row.statusId === "CAL_COMPLETED" ||
                            row.statusId === "CAL_ACKNOWLEDGED"
                              ? "successChip"
                              : "inProgressChip"
                          }
                          label={row.status}
                        />
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          props.openTaskLink(row);
                        }}
                      >
                        {formatDate(row.date)}
                      </TableCell>
                      {(props.securityGroupsList.includes("PARTNER_ADMIN") ||
                        props.securityGroupsList.includes("ADMIN")) && (
                        <TableCell>
                          {row.taskPurpose !== "NOTIFICATION" &&
                            row.statusId !== "CAL_COMPLETED" &&
                            row.statusId !== "CAL_ACKNOWLEDGED" &&
                            row.statusId !== "CAL_WAITING" && (
                              <Button
                                style={{ padding: "2px 8px" }}
                                // className={classes.button2}
                                className={"buttonSecondary"}
                                onClick={(event) =>
                                  props.selectReassignTask(event, row)
                                }
                              >
                                {t("REASSIGN")}
                              </Button>
                            )}
                          {/* <Button
													style={{ padding: "2px 8px" }}
													// className={classes.button2}
													className={"buttonSecondary"}
													aria-describedby={`popper-${index}`}
													type="button"
													onClick={(event) => handleClick(event, row)}
												>
													...
												</Button>
												<Popper id={`popper-${index}`} open={openPopper && selectedRow === row} anchorEl={anchorEl} placement="bottom-start" style={{ zIndex: '99' }}>
													<ClickAwayListener onClickAway={handleClose}>
														<Paper>
															<MenuList>
																<MenuItem
																	onClick={() => {
																		openShowDetails(row, index);
																	}}
																>
																	<span style={{ marginRight: ".5rem", display: "flex", justifyContent: "center" }}>
																		<ViewIconNew />
																	</span>
																	<span style={{ fontSize: "14px" }}>{t("VIEW")}</span>
																</MenuItem>
															</MenuList>
														</Paper>
													</ClickAwayListener>
												</Popper> */}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
              </>
            ) : (
              <>
                <TableRow>
                  <TableCell
                    colSpan={
                      props.securityGroupsList.includes("PARTNER_ADMIN") ? 7 : 5
                    }
                    align="center"
                  >
                    {t("TASK_NOT_FOUND")}
                  </TableCell>
                </TableRow>
              </>
            )}{" "}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalTasksCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {formatNumber(props.totalTasksCount)}
          </label>
          <label>
            {/* Rows per page select */}
            {t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10} classes={{ root: "treeRowPerPageItem" }}>
                10
              </MenuItem>
              <MenuItem value={50} classes={{ root: "treeRowPerPageItem" }}>
                50
              </MenuItem>
              <MenuItem value={100} classes={{ root: "treeRowPerPageItem" }}>
                100
              </MenuItem>
            </Select>
          </label>
          {/* Pagination component */}
          <Pagination
            page={props.page}
            count={Math.ceil(props.totalTasksCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            showFirstButton
            showLastButton
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation("translations")(MyTask);
